module.exports = __webpack_public_path__ + "img/icon-password.5fc532cf.svg";